/* ------------------------------------- MATERIAL UI --------------------------------------- */
import { Button, Card, Container, Grid, Link, Stack, Typography } from '@mui/material';

/* ------------------------------------- REACT JS ------------------------------------------ */
import { useSelector } from 'react-redux';
import { Icon } from '@iconify/react';
import { useNavigate } from 'react-router-dom';

/* ------------------------------------- COMPONENTS ---------------------------------------- */
import Page from '../components/Page';
import { useTranslation } from '../common/LocalizationProvider';
import { codeCountrySelect } from '../components/CountrySelect';
import { selectGroupsArray, selectSession } from '../createSelectorUtils';

const formatNumber = (number) => {
  if (number !== undefined && number !== null) {
    return number.replace(/(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/, '$1 $2 $3 $4 $5');
  }
  return '';
};

function ClubTypography(label, value) {
  if (value !== undefined && value !== null && value !== '' && value !== 0 && value !== '0') {
    switch (label) {
      case 'Phone':
        return (
          <Typography variant="body1" gutterBottom>{`Phone: ${formatNumber(value)}`}</Typography>
        );
      case 'E-mail':
        return (
          <Typography variant="body1" gutterBottom>
            E-mail:{' '}
            <Link color="inherit" underline="none" href={`mailto:${value}`}>
              {value}
            </Link>
          </Typography>
        );
      case 'Website':
        return (
          <Typography variant="body1" gutterBottom>
            Website:{' '}
            <Link color="inherit" underline="none" target="_blank" href={`https://${value}`}>
              {value}
            </Link>
          </Typography>
        );
      default:
        return <Typography variant="body1" gutterBottom>{`${label}: ${value}`}</Typography>;
    }
  }
  return <Typography variant="body1" gutterBottom>{`${label}:`}</Typography>;
}

export default function MyClub() {
  const t = useTranslation();
  const groups = useSelector(selectGroupsArray);
  const session = useSelector(selectSession);
  const { permission } = session;
  const navigate = useNavigate();

  return (
    <Page title={t('myClub_Title')}>
      <Container>
        {groups.map((group, index) => (
          <Card key={index} sx={{ marginTop: '10px' }}>
            <Grid key={index} container spacing={4}>
              <Grid item xs={12} sm={8}>
                <Stack spacing={1} padding={4}>
                  <Stack
                    direction={{ xs: 'column', sm: 'row' }}
                    alignItems="center"
                    justifyContent="space-between"
                    spacing={4}
                  >
                    <Typography variant="h5">{group.name}</Typography>

                    {(session.administrator ||
                      (permission.map((item) => item.groupid).includes(group.id) &&
                        permission.find((item) => item.groupid === group.id).status < 3)) && (
                      <Button
                        variant="contained"
                        onClick={() => navigate('edit', { state: { id: group.id } })}
                        startIcon={<Icon icon="eva:edit-2-fill" />}
                      >
                        {t('btn_Edit')}
                      </Button>
                    )}
                  </Stack>

                  {ClubTypography(t('fields_Address'), group.adresse)}
                  {ClubTypography(t('fields_ExtraAddress'), group.adresseSuite)}
                  {ClubTypography(t('fields_City'), group.ville)}
                  {ClubTypography(t('fields_Postal'), group.codePostal)}
                  {ClubTypography(t('fields_Country'), codeCountrySelect(group.country))}
                  {ClubTypography(t('fields_Distance'), group.distanceLimit)}
                </Stack>
              </Grid>
              <Grid item xs={12} sm={4} style={{ backgroundColor: '#22398D', color: 'white' }}>
                <Stack spacing={2} padding={4}>
                  <Typography variant="h5" gutterBottom>
                    {t('myClub_Contact')}
                  </Typography>
                  {ClubTypography(t('fields_Email'), group.email)}
                  {ClubTypography(t('fields_Phone'), group.phone)}
                  {ClubTypography(t('fields_Website'), group.siteWeb)}
                </Stack>
              </Grid>
            </Grid>
          </Card>
        ))}
      </Container>
    </Page>
  );
}
